/*************** LLEGENDA ********************/

function addLegend(){
	legend = L.control({position: 'bottomright'});
	legend.onAdd = function (map) {
	    var div = L.DomUtil.create('div', 'info legend visor-legend mCustomScrollbar');
		div.id = "mapLegend"; 
	    jQuery.each(mapLegend, function(i, row){
	    	for (var i = 0; i < row.length; i++) {
	    		if(row[i].chck){
	    			if (row[i].symbol.indexOf("circle")>-1){
	    				var midaStr = row[i].symbol.substring(row[i].symbol.indexOf("r="),row[i].symbol.indexOf("style"));
	    				midaStr=midaStr.substring(midaStr.indexOf("=")+2,midaStr.length-2);
	    				var mida=parseFloat(midaStr);
	    										
						var padding_left="16px !important";
						
						div.innerHTML +='<div class="visor-legend-row">'+
		    				'<div class="visor-legend-symbol col-md-4 col-xs-4" style="padding-left:'+padding_left+'">'+row[i].symbol+'</div>'+
		    				'<div class="visor-legend-name col-md-8 col-xs-8" style="float:right;width:40%">'+row[i].name+'</div>'+
		    				'</div>'+
		    				'<div class="visor-separate-legend-row"></div>';	
	    			}
	    			else{
	    			div.innerHTML +='<div class="visor-legend-row">'+
						'<div class="visor-legend-symbol col-md-4 col-xs-4">'+row[i].symbol+'</div>'+
						'<div class="visor-legend-name col-md-8 col-xs-8" style="float:right;">'+row[i].name+'</div>'+
	    				'</div>'+
	    				'<div class="visor-separate-legend-row"></div>';	    			
	    			}	    			
	    		}
	    	}
	    });
	    return div;
	};
	
	ctr_legend = L.control({
		position : 'bottomright'
	});
	ctr_legend.onAdd = function(map) {
		this._div = L.DomUtil.create('div', 'div_barrabotons btn-group-vertical');
		var btllista = L.DomUtil.create('div', 'leaflet-bar btn btn-default btn-sm bt_legend');
		this._div.appendChild(btllista);
		btllista.innerHTML = '<span class="fa fa-list-alt greenfort"></span>';
		return this._div;
	};
	ctr_legend.addTo(map);	
	legend.addTo(map);
}

/*Control llegenda buida o be, q hagi publicat el mapa amb llegenda, 
pero cap opcio de la llegenda marcada*/
function checkEmptyMapLegend(){
	var trobat = false;
	if(typeof mapLegend == "string" ) mapLegend = [mapLegend]
	jQuery.each(mapLegend, function(i, row){
    	for (var i = 0; i < row.length && !trobat; i++) {
    		if(row[i].chck){
    			trobat = true;
    		}
    	}		
	});
	if(trobat){
		addLegend();
		$("#mapLegend").mCustomScrollbar();
	}
}

function createModalConfigLegend(){
	//Obrim modal llegenda
	var html = '<span>&nbsp;&nbsp;&nbsp;&nbsp;'+window.lang.translate('Marca els símbols que vols que es visualitzin')+'</span>';
	html += '<div class="separate-legend-row-all"></div>';
	html += '<div class="legend-row">'+
				'<div class="legend-subrow-all">'+
				'<input id="legend-chck-all" class="col-md-1 legend-chck" type="checkbox">'+
				'<div class="col-md-11 legend-name-all">'+
					window.lang.translate('Tots')+
				'</div>'+
			'</div>';
	var count = 0;
	var layersHtml = {order:[], notorder:[]};
	html += '<ol class="sortable">';
	
	jQuery.each(controlCapes._layers, function(i, item){
		controlLegendPoint = [];
		controlLegendMarker = [];
		controlLegendLine = [];
		controlLegendPol = [];
		layersHtml = addLayerToLegend(item.layer, count,layersHtml);
		count++;
		jQuery.each(item._layers, function(i, sublayer){
			if (sublayer._layers!=undefined && sublayer._layer.length>0){
				jQuery.each(sublayer._layers, function(i, sublayer2){
					layersHtml = addLayerToLegend(sublayer2.layer, count, layersHtml, sublayer2.layerIdParent );
					count++;
				});
			}
			else {
				layersHtml = addLayerToLegend(sublayer.layer, count, layersHtml, sublayer.layerIdParent );
				count++;
			}
		});
	});
	
	jQuery.each(layersHtml.order, function(i, item){
		if(InstamapsUtils.Validator.isValidValue(item)){
			html += item;
		}
	});
	jQuery.each(layersHtml.notorder, function(i, item){
		if(InstamapsUtils.Validator.isValidValue(item)){
			html += item;
		}
	});
	html += '</ol>';
	$('#dialgo_publicar .modal-body .modal-legend').html(html);
	$('#dialgo_publicar .modal-body .modal-legend').show();
	$('.legend-subrow input, .legend-subrow-all input').iCheck({
	    checkboxClass: 'icheckbox_flat-blue',
	    radioClass: 'iradio_flat-blue'
	});	
	
	/*$('.legend-row input.col-md-1').iCheck({
	    checkboxClass: 'icheckbox_flat-blue align-right',
	    radioClass: 'iradio_flat-blue'
	});*/	

	$('.llegenda-subrow input#visor-chck-dinamic').on('ifChecked', function(event){
		$('.llegenda-subrow input#visor-chck-oberta').iCheck('enable');
	});

	$('.llegenda-subrow input#visor-chck-dinamic').on('ifUnchecked', function(event){
		$('.llegenda-subrow input#visor-chck-oberta').iCheck('uncheck');
		$('.llegenda-subrow input#visor-chck-oberta').iCheck('disable');
	});

	$('.llegenda-subrow input#iframe-chck-dinamic').on('ifChecked', function(event){
		$('.llegenda-subrow input#iframe-chck-oberta').iCheck('enable');
	});

	$('.llegenda-subrow input#iframe-chck-dinamic').on('ifUnchecked', function(event){
		$('.llegenda-subrow input#iframe-chck-oberta').iCheck('uncheck');
		$('.llegenda-subrow input#iframe-chck-oberta').iCheck('disable');
	});

	
	$('.legend-subrow-all input').on('ifChecked', function(event){
		  $('.legend-subrow input').iCheck('check');
		//  $('.legend-row input.col-md-1').iCheck('check');
	});
	
	$('.legend-subrow-all input').on('ifUnchecked', function(event){
		  $('.legend-subrow input').iCheck('uncheck');
		//  $('.legend-row input.col-md-1').iCheck('uncheck');
	});	
	
	//$('.sortable').sortable();
	
	$(".sortable").sortable({
		afterMove: function (placeholder, container) {
		  if(oldContainer != container){
			if(oldContainer)
			  oldContainer.el.removeClass("active");
			  container.el.addClass("active");
	  
			oldContainer = container;
		  }
		},
		onDrop: function ($item, container, _super) {
		  container.el.removeClass("active");
		  _super($item, container);
		}
	  });
	  

	  var oldContainer;
	  $(".sortable2").sortable({
		group: 'nested',
		afterMove: function (placeholder, container) {
		  if(oldContainer != container){
			if(oldContainer)
			  oldContainer.el.removeClass("active");
			  container.el.addClass("active");
	  
			oldContainer = container;
		  }
		},
		onDrop: function ($item, container, _super) {
		 container.el.removeClass("active");
		  _super($item, container);
		}		
	  });
	  
	
	
	return html;
}

function generallegendaMapaEdicio(){
		
	var arbreHTML=createModalConfigLegend();	
	var mapLegendTMP = {};
		
	$(arbreHTML).find(".legend-subrow").each(function(index,element){
	
	var businessId = $(element).attr('data-businessId');
		var html=$(element).children(".legend-symbol").html();
		if(html.indexOf('GetLegendGraphic')!= -1){
			html=html.replace(/width:26px;/g,'');
			html=html.replace('png8','png');
		}
		var obj = {
			chck : true,
			symbol : html,
			name : $(element).children(".legend-name").children("input").val(),
			order: index
		};
		if(!mapLegendTMP[businessId]){
			mapLegendTMP[businessId] = [];
		}
		mapLegendTMP[businessId].push(obj);
	
	});
			
	return mapLegendTMP;

}	

function obteLListatCapesEditor(idLayer){	
	var layerType={};

		jQuery.each(controlCapes._layers, function(i, item){
				if(item.layer.options.businessId==idLayer){					
					layerType.serverName= (item.layer.options.nom 
						? item.layer.options.nom.replace('##1','')
						: "");
					layerType.capesOrdre=""+i+"";					
				}	
				
		jQuery.each(item._layers, function(j, item2){
				if(item2.layer.options.businessId==idLayer){					
					layerType.serverName=item2.layer.options.nom.replace('##1','');
					layerType.capesOrdre="sublayer";					
				}			
			});		
			
		});
		return layerType;		
}	

function addLayerToLegend(layer, count, layersHtml, layerIdParent){
	var html = "";
	html += '<ol class="legend-row sortable2">';
	html+='<div class="separate-legend-row"></div>';
	var layerName = layer.options.nom;
	var checked = "";
	if(undefined != mapLegend[layer.options.businessId]){
		//layerName = mapLegend[layer.options.businessId][0].name;
		if(mapLegend[layer.options.businessId][0].chck) checked = 'checked="checked"';
	}
	if (layerIdParent!=undefined){
		 layerName = layer.options.nom;
	}
	if (layerName==="undefined"){
		layerName = layer.options.nom;
	}

	

	//Cluster
	if(layer.options.tipusRang && layer.options.tipusRang == tem_cluster){
		var html2 = LegendUtils.EditorLegend.getRowClusterHeatmapLayerHtml(layer,checked,layerName);	
		if (html2!=="") {
			html += LegendUtils.EditorLegend.getLegendRowName(layerName) + html2;
		}
	//Heatmap
	}else if(layer.options.tipusRang && layer.options.tipusRang == tem_heatmap){
		var html2 = LegendUtils.EditorLegend.getRowClusterHeatmapLayerHtml(layer,checked,layerName);
		if (html2!=="") {
			html += LegendUtils.EditorLegend.getLegendRowName(layerName) + html2;
		}
	//WMS
	}else if(layer.options.tipus == t_wms){
		var html2 = LegendUtils.EditorLegend.getRowWmsLayerHtml(layer,checked,layerName,mapLegend);
		if (html2!=="") {
			html += LegendUtils.EditorLegend.getLegendRowName(layerName) + html2;
		}
	//Dades obertes y JSON
	}else if(layer.options.tipus == t_dades_obertes || layer.options.tipus == t_json){//es un punt
		var html2 = LegendUtils.EditorLegend.getRowJsonLayerHtml(layer,checked,layerName,mapLegend);
		if (html2!=="") {
			html += LegendUtils.EditorLegend.getLegendRowName(layerName) + html2;
		}
	//URL FILE
	}else if(layer.options.tipus == t_url_file){
		var html2 = LegendUtils.EditorLegend.getRowUrlFileLayerHtml(layer,checked,layerName,mapLegend);		
		if (html2!=="") {
			html += LegendUtils.EditorLegend.getLegendRowName(layerName) + html2;
		}
	//XARXES SOCIALS
	}else if(layer.options.tipus == t_xarxes_socials){
		var html2 = LegendUtils.EditorLegend.getRowXarxesLayerHtml(layer,layerName,mapLegend);	
		if (html2!=="") {
			html += LegendUtils.EditorLegend.getLegendRowName(layerName) + html2;
		}
	//VISUALITZACIO
	}else if(layer.options.tipus == t_visualitzacio){		
		if(layer.options.tipusRang==tem_size || layer.options.tipusRang==tem_clasic || (layer.options.tem!==undefined && layer.options.tem==tem_size)){
			var html2 = LegendUtils.EditorLegend.getLlegendaVisualitzacio(layer,mapLegend);
			if (html2!=="") {
				html += LegendUtils.EditorLegend.getLegendRowName(layerName) + html2;
			}
		}
		else{
			var html2 = LegendUtils.EditorLegend.getRowSimpleTematicLayer(layer,checked,layerName,mapLegend);
			if (html2!=="") {
				html += LegendUtils.EditorLegend.getLegendRowName(layerName) + html2;
			}
		}		
	}

	html+='</ol>';
	if(undefined!=mapLegend[layer.options.businessId]){
		if (mapLegend[layer.options.businessId][0].order >= 0){
			layersHtml.order[mapLegend[layer.options.businessId][0].order] = html;
		}else{
			layersHtml.notorder.push(html);
		}
	}else{
		layersHtml.notorder.push(html);
	}
	
	
	return layersHtml;
}

function checkLineStyle(obj){
	var existeix = false;
	for(var i=0; i<controlLegendLine.length && !existeix;i++){
		var item = controlLegendLine[i];
		if ( obj.color!==null) {
		if(item.lineWidth == obj.lineWidth && 
				item.color.r == obj.color.r && 
				item.color.g == obj.color.g && 
				item.color.b == obj.color.b) existeix = true;
		}
	}
	return existeix;
}

function checkPolStyle(obj){
	var existeix = false;
	for(var i=0; i<controlLegendPol.length && !existeix;i++){
		var item = controlLegendPol[i];
		if (obj.borderColor!==null && obj.color!==null) {
			if(item.opacity == obj.opacity && 
				item.borderWidth == obj.borderWidth &&
				item.borderColor.r == obj.borderColor.r && 
				item.borderColor.g == obj.borderColor.g && 
				item.borderColor.b == obj.borderColor.b	&&			
				item.color.r == obj.color.r && 
				item.color.g == obj.color.g && 
				item.color.b == obj.color.b) existeix = true;
		}
	}
	return existeix;
}

function checkPointStyle(obj){
	var existeix = false;
	for(var i=0; i<controlLegendPoint.length && !existeix;i++){
		var item = controlLegendPoint[i];
		if (obj.colorIcon!==null && obj.color!==null) {
			if(item.iconSize == obj.iconSize && 
				item.icon == obj.icon &&
				item.colorIcon.r == obj.colorIcon.r && 
				item.colorIcon.g == obj.colorIcon.g && 
				item.colorIcon.b == obj.colorIcon.b	&&			
				item.color.r == obj.color.r && 
				item.color.g == obj.color.g && 
				item.color.b == obj.color.b) existeix = true;
		}
	}
	return existeix;
}

function checkMarkerStyle(obj){
	var existeix = false;
	for(var i=0; i<controlLegendMarker.length && !existeix;i++){
		var item = controlLegendMarker[i];
		if (obj.color!==null) {
		if(item.marker == obj.marker && 
				item.simbol == obj.simbol &&
				item.color.r == obj.color.r && 
				item.color.g == obj.color.g && 
				item.color.b == obj.color.b) existeix = true;
		}
	}
	return existeix;
}

function findLabelCategoria(rang, rangsField){
	if(rang.valorMin){
		return rangsField +": "+rang.valorMin +" - "+ rang.valorMax;
	}else{
		return rang.valorMax;
	}
}

//This will sort your array
function sortByValorMax(a, b){
	var aName = a.valorMax.toLowerCase();
	var bName = b.valorMax.toLowerCase(); 
	return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
//	if (a.valorMax < b.valorMax) return -1;
//	if (a.valorMax > b.valorMax) return 1;
//	return 0;	
}



function sortObject(obj) {
    var arr = [];
    for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
            arr.push({
                'key': prop,
                'value': obj[prop]
            });
        }
    }
    return arr;
}

function updateMapLegendData(){
	mapLegend = {};
	$(".legend-subrow").each(function(index,element){
		var businessId = $(element).attr('data-businessId');
		var html=$(element).children(".legend-symbol").html();
		if(html.indexOf('GetLegendGraphic')!= -1){
			html=html.replace(/width:26px;/g,'');
			html=html.replace('png8','png');
		}
		var obj = {
			chck : $(element).children(".icheckbox_flat-blue").hasClass("checked"),
			symbol : html,
			name : $(element).children(".legend-name").children("input").val(),
			order: index,
			estilKey: $(element).children(".legend-symbol").attr('data-estilkey'),
		};
		if(!mapLegend[businessId]){
			mapLegend[businessId] = [];
		}		
		var idTab = "tab"+businessId;
		//Actualitzem llegenda editor
		if (businessId!==undefined && $('#'+idTab +' .visor-legend-row .visor-legend-name span')[0]!==undefined) {
			$('#'+idTab +' .visor-legend-row .visor-legend-name span')[0].innerHTML = $(element).children(".legend-name").children("input").val();
		}
		mapLegend[businessId].push(obj);
	});
	
	
}

function findStyleInLegend(legend,stringStyle){
	var index = -1;
	for(var i=0; i<legend.length;i++){
		if (stringStyle!==undefined) {
			if(legend[i].symbol.trim() == stringStyle.trim()){
				index = i;
				break;
			}		
		}
	}
	return index;
}

function checkColorAdded(controlColorCategoria, color){
	var existeix = false;
	for(var i=0; i<controlColorCategoria.length && !existeix;i++){	
		if (controlColorCategoria[i].r == color.r &&
				controlColorCategoria[i].g == color.g &&
				controlColorCategoria[i].b == color.b) existeix = true;
	}
	return existeix;
}

function addHtmlModalLegend(){
	
	jQuery('#mapa_modals').append(
	'<!-- Modal Llegenda -->'+
	'		<div id="dialog_llegenda" class="modal fade">'+
	'		<div class="modal-dialog">'+
	'			<div class="modal-content">'+
	'				<div class="modal-header">'+
	'					<button type="button" class="close" data-dismiss="modal"'+
	'						aria-hidden="true">&times;</button>'+
	'					<h4 lang="ca" class="modal-title">Llegenda</h4>'+
	'				</div>'+
	'				<div class="modal-body">'+
	'				</div>'+
	'				<div class="modal-footer">'+
	'					<button lang="ca" type="button" class="btn btn-default"'+
	'						data-dismiss="modal">Cancel·lar</button>'+
	'					<button lang="ca" type="button" class="btn btn-primary">Preview</button>'+
	'				</div>'+
	'			</div>'+
	'			<!-- /.modal-content -->'+
	'		</div>'+
	'		<!-- /.modal-dialog -->'+
	'	</div>'+
	'	<!-- /.modal -->'+
	'	<!-- Fi Modal Llegenda -->'		
	);
}

/*************** FI:LLEGENDA ********************/


/**** LLEGENDA TEMATICA MODE EDICIO ****/

function addLegendEdicio(){
	
	try{

			ctr_legend = L.control.legend({
				title: window.lang.translate('Llegenda'),
				tipusllegenda: "dinamica",  //"dinamica"
				llegendaOpt: true      //true
			});
			ctr_legend.addTo(map);
	
	}catch(Err){
		
		//$.publish('analyticsEvent',{event:['error', 'AddLlegendaEdicio',JSON.stringify(Err)]});
	
	}	
	
}

function emptyMapLegendEdicio(layer,isOrigen){
	if($("#mapLegendEdicio").data("businessid") == layer.options.businessId ){
		$("#mapLegendEdicio").html("");
		activaLlegenda(false);
		$(".bt_legend").hide();
	}
	else if (isOrigen){
		$("#mapLegendEdicio").html("");
		activaLlegenda(false);
		$(".bt_legend").hide();
	}
}

function loadMapLegendEdicio(layer){
		
	//Eliminem de la lleganda tematització anterior
	$("#mapLegendEdicio").html("");
	$("#mapLegendEdicio").data("businessid",layer.options.businessId);
	
	var html="";
	if(layer.options.tipus == t_wms){
		html = '<div class="titol-legend col-md-12 col-xs-12">'+layer.options.nom+'</div><div class="titol-separate-legend-row"></div>';
	}
	else{
		html = '<div class="titol-legend col-md-12 col-xs-12">'+layer.options.nom+' ('+layer.getLayers().length+')</div><div class="titol-separate-legend-row"></div>';
			
	}
	var geometryType = InstamapsUtils.Geo.transformTipusGeometry(layer.options.geometryType, InstamapsConstants);
	var i = 0;
	if(layer.options.tipus == t_wms){	
		var legend_layer = layer.getLegendGraphic();
		html += '<div class="visor-legend-row ">';
		
		if(!jQuery.isArray(legend_layer)){
			html += '<a href="'+layer.getLegendGraphic()+'" data-lightbox="image-'+layer.options.businessId+'"><img src="'+layer.getLegendGraphic()+'" class="btn-paleta img-legend"/></a>';
		}else{
			jQuery.each(legend_layer, function(i, lay){
				html += '<a href="'+lay+'" data-lightbox="image-'+layer.options.businessId+'"><img src="'+lay+'" class="btn-paleta img-legend"/></a>';
			});
		}
		html+='</div><div class="visor-separate-legend-row"></div>';
	}
	else{
		var estilsRangs = layer.options.estilsRangs;
		var rangsEstilsLegend = layer.options.rangsEstilsLegend;
		
		var arrRangsEstilsLegend = sortObject(rangsEstilsLegend);
		console.log(arrRangsEstilsLegend);
		//arrRangsEstilsLegend.sort(InstamapsUtils.Sort.sortByValueMax);
		
		var totalLayers=0;
		
		if(geometryType == t_marker){

			jQuery.each(arrRangsEstilsLegend, function(i, estilRang){
				var indexEstil = 0;
				while(indexEstil<layer.options.estil.length && estilRang.key!=layer.options.estil[indexEstil].businessId){
					indexEstil++;
					
				}
				totalLayers = totalLayers+layer.options.estil[indexEstil].geometria.features.length;
				var mida = InstamapsUtils.Styles.getMidaFromRadius(layer.options.estil[indexEstil].simbolSize);
				if (layer.options.tipusRang == tem_size) mida = layer.options.estil[indexEstil].simbolSize;
				var iconSize = 'width: '+mida+'px; height: '+mida+'px; font-size: 8px;';						
				var color = InstamapsUtils.Colors.hexToRgb(layer.options.estil[indexEstil].color);
				if(mida>=60) mida=60;
				var height=mida*2.8;
				var padding_left="16px !important";
				var stringStyle = InstamapsUtils.Styles.getSvgFromRadius(mida,color,$(location).attr('href'));
				var labelNomCategoria = "";
				var index=-1;
				if (layer.options.tipusRang!=tem_size){
					stringStyle ='<div class="awesome-marker-web awesome-marker-icon-punt_r legend-symbol" '+
						'style="background-color: '+InstamapsUtils.Colors.getRgbText(color)+'; '+
						' '+iconSize+'">'+
					'</div>';
					index = mapLegend[layer.options.businessId]?findStyleInLegend(mapLegend[layer.options.businessId],stringStyle):-1;					
				}
				else {
					var stringStyle2 = InstamapsUtils.Styles.getSvgForLegendFromRadius(mida,color,$(location).attr('href'));
					index = mapLegend[layer.options.businessId]?findStyleInLegend(mapLegend[layer.options.businessId],stringStyle2):-1;						
				}
				labelNomCategoria = LegendUtils.EditorLegend.getLabelNomCategoria(layer,rangsEstilsLegend,index,indexEstil,mapLegend);	
				
				
				html += '<div class="visor-legend-row ">';
				if (layer.options.tipusRang == tem_size){
					html +=	'<div class="visor-legend-symbol col-md-4 col-xs-4" style="padding-left:'+padding_left+'">'+
						stringStyle+
						'</div>'+
						'<div class="visor-legend-name col-md-8 col-xs-8" style="float:right;width:40%">'+labelNomCategoria+'</div>';	
				}
				else{
					html +=	'<div class="visor-legend-symbol col-md-4 col-xs-4">'+
							stringStyle+
						'</div>'+
						'<div class="visor-legend-name col-md-8 col-xs-8">'+labelNomCategoria+'</div>';				
				}
				html+='</div><div class="visor-separate-legend-row"></div>';	
			});
		}else if(geometryType == t_polyline){
			
			jQuery.each(arrRangsEstilsLegend, function(i, estilRang){
				var indexEstil = 0;
				while(indexEstil<layer.options.estil.length && estilRang.key!=layer.options.estil[indexEstil].businessId){
					indexEstil++;
				}
				totalLayers = totalLayers+layer.options.estil[indexEstil].geometria.features.length;
				var color = InstamapsUtils.Colors.hexToRgb(layer.options.estil[indexEstil].color);
				var lineWidth = layer.options.estil[indexEstil].lineWidth;
				var stringStyle =	'<svg height="20" width="20">'+
						'<line x1="0" y1="20" x2="20" y2="0" '+
							'style="stroke:'+InstamapsUtils.Colors.getRgbText(color)+'; stroke-width:'+lineWidth+';"></line>'+
					'</svg>';	
				
				var labelNomCategoria = "";
				checked = "";						
				
				var index=-1;
				if (undefined!=mapLegend[layer.options.businessId]) {
					index = mapLegend[layer.options.businessId]?findStyleInLegend(mapLegend[layer.options.businessId],stringStyle):-1;
				}
				labelNomCategoria = LegendUtils.EditorLegend.getLabelNomCategoria(layer,rangsEstilsLegend,index,indexEstil,mapLegend);	
				
				html += '<div class="visor-legend-row ">';
				html +=	'<div class="visor-legend-symbol col-md-4 col-xs-4">'+
						stringStyle+
					'</div>'+
					'<div class="visor-legend-name col-md-8 col-xs-8">'+labelNomCategoria+'</div>';				
				
				html+='</div><div class="visor-separate-legend-row"></div>';
			});				
			
		}else{
			//poligons categories
			jQuery.each(arrRangsEstilsLegend, function(i, estilRang){
				var indexEstil = 0;
				while(indexEstil<layer.options.estil.length && estilRang.key!=layer.options.estil[indexEstil].businessId){
					indexEstil++;
				}
				totalLayers = totalLayers+layer.options.estil[indexEstil].geometria.features.length;
				var color = "";
				if (layer.options.estil[indexEstil].color) color=InstamapsUtils.Colors.hexToRgb(layer.options.estil[indexEstil].color);
				else color=InstamapsUtils.Colors.hexToRgb(layer.options.estil[indexEstil].borderColor);
				var borderColor = InstamapsUtils.Colors.hexToRgb(layer.options.estil[indexEstil].borderColor);
				var opacity = layer.options.estil[indexEstil].opacity;				
				if (opacity!==0.25 && opacity!==0.5 && opacity!==0.75) opacity = opacity/100;
				var borderWidth = layer.options.estil[indexEstil].borderWidth;		
				if (borderWidth==0) borderWidth=1;
				var stringStyle =	'<svg height="20" width="20">'+
						'<polygon points="5 5, 5 25, 25 25, 25 5" stroke-linejoin="round" '+
							'style=" fill:'+InstamapsUtils.Colors.getRgbText(color)+'; stroke:'+InstamapsUtils.Colors.getRgbText(borderColor)+'; stroke-width:'+borderWidth+'; fill-rule:evenodd; fill-opacity:'+opacity+';"></polygon>'+
					'</svg>';	
				
				var labelNomCategoria = "";
				checked = "";						
				
				var index=-1;
				if (undefined!=mapLegend[layer.options.businessId]) {
					index = mapLegend[layer.options.businessId]?findStyleInLegend(mapLegend[layer.options.businessId],stringStyle):-1;
				}
				labelNomCategoria = LegendUtils.EditorLegend.getLabelNomCategoria(layer,rangsEstilsLegend,index,indexEstil,mapLegend);	
				
				html += '<div class="visor-legend-row " >';
				html +=	'<div class="visor-legend-symbol col-md-4 col-xs-4">'+
						stringStyle+
					'</div>'+
					'<div class="visor-legend-name col-md-8 col-xs-8">'+labelNomCategoria+'</div>';				
				html+='</div><div class="visor-separate-legend-row"></div>';
			});					
			
		}	
	}
	html= html.replace("totalLayers",totalLayers);
	$("#mapLegendEdicio").html(html);
	//Afegim de nou les classes i l'scroll
	$("#mapLegendEdicio").addClass("info");
	$("#mapLegendEdicio").addClass("legend");
	$("#mapLegendEdicio").addClass("visor-legend");
	$("#mapLegendEdicio").addClass("mCustomScrollbar");
	$("#mapLegendEdicio").mCustomScrollbar();
	
	//$(".bt_legend").show();
	//activaLlegenda(true);
	
}


function loadMapLegendEdicioDinamics(layer){
	
	//Eliminem de la lleganda tematització anterior
	$("#mapLegendEdicio").html("");
	$("#mapLegendEdicio").data("businessid",layer.options.businessId);
	
	var html = '<div class="titol-legend col-md-12 col-xs-12">'+layer.options.nom+' ('+layer.getLayers().length+')</div><div class="titol-separate-legend-row"></div>';
	
	var geometryType = InstamapsUtils.Geo.transformTipusGeometry(layer.options.geometryType, InstamapsConstants);

	var rangsEstilsLegend = layer.options.estil_do.estils;
	
		if(geometryType == t_marker){
			var map={};
			jQuery.each(layer._layers, function(i, lay){
				if (layer.options.tem=='sizeTematic'){
					var radius=lay.options.radius;
					if (radius!=undefined){
						if (map[radius]==undefined) map[radius]=1;
						else {
							var i=map[radius];
							map[radius]=i+1;
						}
					}
				}
				else{
					var color = lay.options.fillColor;
					if (color!=undefined){
						if (map[color]==undefined) map[color]=1;
						else {
							var i=map[color];
							map[color]=i+1;
						}
					}
				}
			});
		jQuery.each(rangsEstilsLegend, function(i, estilRang){
			var mida = InstamapsUtils.Styles.getMidaFromRadius(estilRang.estil.simbolSize);
			if (layer.options.tem == tem_size) mida = estilRang.estil.simbolSize;
			var padding_left="16px !important";
			var color = InstamapsUtils.Colors.hexToRgb(estilRang.estil.color);
			var height=mida*2.8;
			var iconSize = 'width: '+mida+'px; height: '+mida+'px; font-size: 8px;';						
			var stringStyle = InstamapsUtils.Styles.getSvgFromRadius(mida,color,$(location).attr('href'));
			
			if (layer.options.tem != tem_size) {
				stringStyle ='<div class="awesome-marker-web awesome-marker-icon-punt_r legend-symbol" '+
				'style="background-color: '+InstamapsUtils.Colors.getRgbText(color)+'; '+
				' '+iconSize+'">'+
				'</div>';
			}	
			var labelNomCategoria = "";
			
			if (estilRang.valueMax == estilRang.valueMin){
				labelNomCategoria = estilRang.valueMax;
			}
			else {
				labelNomCategoria = estilRang.valueMin+"-"+ estilRang.valueMax;
			}
			
			if (layer.options.tem=='sizeTematic'){
				if (labelNomCategoria.indexOf('('+map[estilRang.estil.simbolSize]+')')==-1){
					labelNomCategoria = labelNomCategoria+' ('+map[estilRang.estil.simbolSize]+')';
				}
			}
			else{
				if (labelNomCategoria.indexOf('('+map[estilRang.estil.color]+')')==-1){
					labelNomCategoria = labelNomCategoria+' ('+map[estilRang.estil.color]+')';
				}
			}
			
			html += '<div class="visor-legend-row ">';
			if (layer.options.tem == tem_size) {
				html +=	'<div class="visor-legend-symbol col-md-4 col-xs-4" style="margin-top:4px;padding-left:'+padding_left+'">'+
					stringStyle+
					'</div>'+
					'<div class="visor-legend-name col-md-8 col-xs-8" style="padding-left:50px;">'+labelNomCategoria+'</div>';	
				}
			else {
				html +=	'<div class="visor-legend-symbol col-md-4 col-xs-4">'+
					stringStyle+
				'</div>'+
				'<div class="visor-legend-name col-md-8 col-xs-8">'+labelNomCategoria+'</div>';
			}
			html+='</div><div class="visor-separate-legend-row"></div>';	
			
		});
	}else if(geometryType == t_polyline){
		var map={};
		jQuery.each(layer._layers, function(i, lay){
			var color = lay.options.color;
			if (color!=undefined){
				if (map[color]==undefined) map[color]=1;
				else {
					var i=map[color];
					map[color]=i+1;
				}
			}
		});
		jQuery.each(rangsEstilsLegend, function(i, estilRang){
			
			var color = InstamapsUtils.Colors.hexToRgb(estilRang.estil.color);
			var lineWidth = estilRang.estil.lineWidth;
			var stringStyle =	'<svg height="20" width="20">'+
					'<line x1="0" y1="20" x2="20" y2="0" '+
						'style="stroke:'+InstamapsUtils.Colors.getRgbText(color)+'; stroke-width:'+lineWidth+';"></line>'+
				'</svg>';	
			
			var labelNomCategoria = "";
								
			if (estilRang.valueMax == estilRang.valueMin){
				labelNomCategoria = estilRang.valueMax;
			}
			else {
				labelNomCategoria = estilRang.valueMin+"-"+ estilRang.valueMax;
			}	
			
			if (labelNomCategoria.indexOf('('+map[estilRang.estil.color]+')')==-1){
				labelNomCategoria = labelNomCategoria+' ('+map[estilRang.estil.color]+')';
			}
			
			html += '<div class="visor-legend-row ">';
			html +=	'<div class="visor-legend-symbol col-md-4 col-xs-4">'+
					stringStyle+
				'</div>'+
				'<div class="visor-legend-name col-md-8 col-xs-8">'+labelNomCategoria+'</div>';			
			html+='</div><div class="visor-separate-legend-row"></div>';
		});				
		
	}else{
		var map={};
		jQuery.each(layer._layers, function(i, lay){
			if (lay.options!=undefined){
				if (lay.options.fillColor!=undefined) {
					var color = lay.options.fillColor;
					if (color!=undefined){
						if (map[color]==undefined) map[color]=1;
						else {
							var i=map[color];
							map[color]=i+1;
						}
					}
				}				
			}
			else {
				if (lay.getLayers()[0].options!=undefined){
					if (lay.getLayers()[0].options.fillColor!=undefined) {
						var color = lay.getLayers()[0].options.fillColor;
						if (color!=undefined){
							if (map[color]==undefined) map[color]=1;
							else {
								var i=map[color];
								map[color]=i+1;
							}
						}
					}				
				}
			}
		});
		jQuery.each(rangsEstilsLegend, function(i, estilRang){
			
			var color = "";
			if (estilRang.estil.color) color=InstamapsUtils.Colors.hexToRgb(estilRang.estil.color);
			else color=InstamapsUtils.Colors.hexToRgb(estilRang.estil.borderColor);
			var borderColor = InstamapsUtils.Colors.hexToRgb(estilRang.estil.borderColor);
			var opacity = estilRang.estil.opacity;
			if (opacity!==0.25 && opacity!==0.5 && opacity!==0.75) opacity = opacity/100;
			var borderWidth = estilRang.estil.borderWidth;
			if (borderWidth==0) borderWidth=1;
			var stringStyle =	'<svg height="20" width="20">'+
					'<polygon points="5 5, 5 25, 25 25, 25 5" stroke-linejoin="round" '+
						'style=" fill:'+InstamapsUtils.Colors.getRgbText(color)+'; stroke:'+InstamapsUtils.Colors.getRgbText(borderColor)+'; stroke-width:'+borderWidth+'; fill-rule:evenodd; fill-opacity:'+opacity+';"></polygon>'+
				'</svg>';	
			
			var labelNomCategoria = "";
			
			if (estilRang.valueMax == estilRang.valueMin){
				labelNomCategoria = estilRang.valueMax;
			}
			else {
				labelNomCategoria = estilRang.valueMin+"-"+ estilRang.valueMax;
			}	
			
			if (labelNomCategoria.indexOf('('+map[estilRang.estil.color]+')')==-1){
				labelNomCategoria = labelNomCategoria+' ('+map[estilRang.estil.color]+')';
			}
			
			html += '<div class="visor-legend-row ">';
			html +=	'<div class="visor-legend-symbol col-md-4 col-xs-4">'+
					stringStyle+
				'</div>'+
				'<div class="visor-legend-name col-md-8 col-xs-8">'+labelNomCategoria+'</div>';
			html+='</div><div class="visor-separate-legend-row"></div>';
		});					
		
	}	
	
	$("#mapLegendEdicio").html(html);
	//Afegim de nou les classes i l'scroll
	$("#mapLegendEdicio").addClass("info");
	$("#mapLegendEdicio").addClass("legend");
	$("#mapLegendEdicio").addClass("visor-legend");
	$("#mapLegendEdicio").addClass("mCustomScrollbar");
	$("#mapLegendEdicio").mCustomScrollbar();
	
	//$(".bt_legend").show();
	//activaLlegenda(true);
	
}

/**** fi/LLEGENDA TEMATICA MODE EDICIO ****/

function activaLlegenda(obre) {
	var dfd = $.Deferred();
	var cl = jQuery('.bt_legend span').attr('class');
	var funcioObrir = (obre!=undefined ? obre : cl.indexOf('grisfort') != -1);
	if (funcioObrir) {
		jQuery('.bt_legend span').removeClass('grisfort');
		jQuery('.bt_legend span').addClass('greenfort');
		$(".bt_legend").transition({ x: '0px', y: '0px',easing: 'in', duration: 500 });
		$(".visor-legend").transition({ x: '0px', y: '0px',easing: 'in', opacity: 1,duration: 500 });
	} else {
		jQuery('.bt_legend span').removeClass('greenfort');
		jQuery('.bt_legend span').addClass('grisfort');
		var height = $(".visor-legend").height();
		var y1 = $(".visor-legend").height() - 20;
		var y2 = $(".visor-legend").height() +50;
		$(".bt_legend").transition({ x: '225px', y: y1+'px',duration: 500 });
		$(".visor-legend").transition({ x: '250px', y: y2+'px',  opacity: 0.1,duration: 500 });		
	}	
	dfd.resolve();
	return dfd.promise();
}